<template>
  <div class="modal fade" id="drAcheiModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <component ref="modalContent" :is="content" :route="route" @changeTo="change($event)">
        <loading v-if="innerLoading"></loading>
      </component>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import Login from '@/components/LoginCliente'
import AdquirirSinSaude from '@/components/AdquirirSinSaude'
import EsqueciSenhaCliente from '@/components/EsqueciSenhaCliente'
import ChangePassword from '@/components/ChangePassword'
import ModalUploadLogo from '@/components/ModalUploadLogo'
import ModalUploadImageRede from '@/components/ModalUploadImageRede'
import LoginCompraPlano from '@/components/LoginCompraPlano'
import ModalIrParaOrcamento from '@/components/ModalIrParaOrcamento'

export default {
  props: {
    selectedComponent: {
      type: String,
      required: true
    },

    route: {
      type: String,
      required: false
    }
  },

  computed: {
    innerLoading () {
      return this.$store.getters.innerLoading
    },

    content: {
      set (newValue) {
        return newValue
      },
      get () {
        return this.selectedComponent
      }
    }
  },

  components: {
    Loading,
    Login,
    AdquirirSinSaude,
    EsqueciSenhaCliente,
    ChangePassword,
    ModalUploadLogo,
    ModalUploadImageRede,
    LoginCompraPlano,
    ModalIrParaOrcamento
  },

  methods: {
    change (componentName) {
      this.$emit('change', componentName)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue